import * as AbsintheSocket from '@absinthe/socket'
import phoenixSocket from './phoenixSocket'

const absintheSocket = AbsintheSocket.create(phoenixSocket)

export default absintheSocket



// WEBPACK FOOTER //
// ./src/config/absintheSocket.js